import * as yup from 'yup'
import { pt } from 'yup-locale-pt'

yup.setLocale(pt)

export const validationSchema = yup.object().shape({
  reward_item_id: yup.string().required().label('Variação'),
  quantity: yup
    .number()
    .required()
    .min(1, 'Quantidade mínima é 1')
    .max(99, 'Quantidade máxima é 99')
    .label('Quantidade')
})
